

const APIConfig = {
  APILOCALURL: "https://localhost:7060/api/",
  APISERVERURL: "https://magentsapi.azurewebsites.net/api/",
  APIACTIVEURL: "https://magentsapi.azurewebsites.net/api/",

  LOGIN: "Auth/login",
  CHANGE_PASSWORD: "Auth/change-password",

  PROJECT_GET_ALL: "Project/GetAll",
  PROJECT_BASE: "Project", 
  
  PLOT_GET_ALL: "Plot/GetAll",
  PLOT_SUGGESTIONS: "Plot/GetSuggestions",
  PLOT_BASE: "Plot",



   STAFF_GET_ALL: "Staff/GetAll",
  STAFF_BASE: "Staff", 
  STAFF_SUGGESTIONS: "Staff/GetSuggestions", 


   MEMBER_GET_ALL: "Member/GetAll",
  MEMBER_BASE: "Member",

  MEMBER_GET_BY_PLOT: "Member/GetByPlot",
  MEMBER_GET_BY_STAFF: "Member/GetByStaff",

  STAFF_SUGGESTIONS: "Staff/GetSuggestions", // Assuming you have a suggestion endpoint
PLOT_SUGGESTIONS: "Plot/GetSuggestions",


 // Add these to your APIConfig object
MEMBER_DOC_UPLOAD: "MemberDocument/upload",
MEMBER_DOC_GET_BY_MEMBER: "MemberDocument/GetByMemberId",
MEMBER_DOC_DELETE: "MemberDocument",


  PAYMENT_GET_ALL: "Payment/GetAll",
  PAYMENT_BASE: "Payment",
  PAYMENT_GET_BY_MEMBER: "Payment/GetByMember",
  PAYMENT_GET_BY_PLOT: "Payment/GetByPlot",



 HOLIDAY_GET_ALL: "Holiday/GetAll",
  HOLIDAY_BASE: "Holiday",
  HOLIDAY_GET_BY_MEMBER: "Holiday/GetByMember",
  MEMBER_SUGGESTIONS: "Member/GetSuggestions",
  

  // Add these to your APIConfig object
BRANCH_GET_ALL: "Branch/GetAll",
BRANCH_BASE: "Branch",
BRANCH_SUGGESTIONS: "Branch/GetSuggestions",


DESIGNATION_GET_ALL: "Designation/GetAll",
DESIGNATION_BASE: "Designation",

LEAD_GET_ALL: "Lead/GetAll",
LEAD_BASE: "Lead",
  
PERMISSION_GET_STAFF: "Permission/GetStaffWithLogin",
PERMISSION_GET_BY_STAFF: "Permission/GetByStaff",
PERMISSION_UPDATE: "Permission/Update",


COMPANY_PROFILE_BASE: "CompanyProfile",
  COMPANY_PROFILE_UPSERT: "CompanyProfile/upsert",

  AGENT_GET_ALL: "Agent/GetAll",
  AGENT_BASE: "Agent",
  
  RECEIPT_GET_ALL: "Receipt/GetAll",
  RECEIPT_BASE: "Receipt",
  RECEIPT_GET_BY_MEMBER: "Receipt/GetByMember",

     AGENT_PERMISSION_GET_WITH_LOGIN: "AgentPermission/GetAgentsWithLogin",
    AGENT_PERMISSION_GET_BY_AGENT: "AgentPermission/GetByAgent", 
    AGENT_PERMISSION_UPDATE: "AgentPermission/Update"
  
};

export default APIConfig;

